import { EVENT_DETAIL_URL } from '@/constants/calendar';
import { CalendarEvent } from '@/store/calendarStore';
import { changeDateForm } from '@/utils';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import ColorBox from '../ui/ColorBox';

const SearchResult = ({ event }: { event: CalendarEvent }) => {
  const navigate = useNavigate();

  const resultclick = id => {
    navigate(`${EVENT_DETAIL_URL}?id=${id}`, { state: 'detail' });
  };

  const formattedDate = changeDateForm(event.start, event.end);
  const time = formattedDate.split('/');

  // Convert YYYY.MM.DD to YY.MM.DD format
  const formatToYYMMDD = (dateStr: string) => {
    return dateStr.replace(
      /(\d{4})\.(\d{2})\.(\d{2})/g,
      (match, year, month, day) => {
        const yy = year.slice(-2);
        return `${yy}.${month}.${day}`;
      }
    );
  };

  const formattedDateYYMMDD = formatToYYMMDD(time[0]);

  return (
    <div
      onClick={() => resultclick(event.id)}
      className={`w-full px-4 border-b border-gray-300 box-border flex gap-4 items-center justify-between cursor-pointer hover:bg-[#fccb1660] min-w-0 ${
        isMobile ? 'h-20' : 'h-12'
      }`}
    >
      <span
        className={`!text-sm md:!text-base font-medium flex-shrink-0 ${isMobile ? 'w-1/2' : 'w-40'}`}
      >
        {formattedDateYYMMDD}
        {time[1] && (
          <span className='!text-xs md:!text-sm font-medium block'>
            {time[1]}
          </span>
        )}
      </span>
      <div
        className={`flex items-center gap-2 !text-sm md:!text-base font-bold flex-1 min-w-0 ${isMobile ? 'w-1/2' : 'w-80'}`}
      >
        <ColorBox color={event.backgroundColor} />
        <span className='flex-1 min-w-0 whitespace-nowrap overflow-hidden text-ellipsis'>
          {event.summary}
        </span>
      </div>
      {!isMobile && (
        <span className='w-60 !text-xs md:!text-sm font-medium whitespace-nowrap overflow-hidden text-ellipsis'>
          {event.location ? event.location : '-'}
        </span>
      )}
    </div>
  );
};

export default SearchResult;
